module.exports = __webpack_public_path__ + "img/lg01.5f890a7f.svg";